<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>

<div class="header-bar">
  <h1>Organisation: {{ customer?.name?.value }}</h1>
</div>

<div class="content-container" *ngIf="newCustomerForm">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title">
      <h2 class="sub-header-bar">Primary Address</h2>
      <form
        [formGroup]="newCustomerForm"
        (ngSubmit)="save(newCustomerForm.getRawValue())"
        autocomplete="off"
      >
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12 ui-g-nopad">
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Name</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="name"
                  autocomplete="chrome-off"
                  (change)="checkOrganisationName($event.target.value)"
                  formControlName="name"
                  tabindex="1"
                  maxlength="100"
                  class="form-component"
                  [disabled]="!isVmeMode"
                  [readonly]="!isVmeMode"
                />

                <div *ngIf="invalidOrganisationName">
                  <span style="color: #c00">Organisation with this name already exists</span>
                </div>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Address Line 1</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="addressLine1"
                  formControlName="addressLine1"
                  tabindex="2"
                  maxlength="60"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Address Line 2</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="addressLine2"
                  formControlName="addressLine2"
                  tabindex="3"
                  maxlength="60"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Address Line 3</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="addressLine3"
                  formControlName="addressLine3"
                  tabindex="4"
                  maxlength="60"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Town</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="town"
                  formControlName="town"
                  tabindex="5"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Post Code</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="postcode"
                  formControlName="postcode"
                  tabindex="6"
                  maxlength="8"
                  class="form-component"
                  (ngModelChange)="onPostcodeChange($event)"
                />
              </div>
            </div>

            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Region </label></div>
              <div class="ui-grid-col-8">
                {{ engineiusRegion?.name }}
                <span *ngIf="engineiusRegion != null && engineiusRegion.engineiusArea != null">
                  ({{ engineiusRegion?.engineiusArea?.name }})
                </span>
              </div>
            </div>

            <div
              *ngIf="
                customerdata &&
                (customerdata?.organisationTypeId == 1 || customerdata?.organisationTypeId == 3)
              "
              class="ui-g-12"
            >
              <div class="ui-grid-col-4">
                <label>Preferred Transport Mode</label>
              </div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  [options]="transportModeOptions"
                  formControlName="transportMode"
                  styleClass="form-component"
                >
                </p-dropdown>
              </div>
            </div>

            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Date Of Birth</label></div>
              <div class="ui-grid-col-8">
                <p-calendar
                  [showIcon]="false"
                  formControlName="dateOfBirth"
                  name="dateOfBirth"
                  dateFormat="dd/mm/yy"
                  placeholder="dd/mm/yyyy"
                  dataType="string"
                ></p-calendar>
              </div>
            </div>
            <div class="ui-g-12">
              <div *ngIf="selectOrganisationType == 3 || selectOrganisationType == 4">
                <div class="ui-grid-col-4"><label>Allow Carryover</label></div>
                <div class="ui-grid-col-8">
                  <p-inputSwitch
                    binary="true"
                    name="allowCarryover"
                    formControlName="allowCarryover"
                    [disabled]="currentUserOrgTypeId != 1"
                  ></p-inputSwitch>
                </div>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>2FA Status</label></div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  [options]="twoFactorStatuses"
                  formControlName="twoFactorStatus"
                  autoWidth="false"
                  styleClass="form-component"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="ui-g-12">
              <div *ngIf="selectOrganisationType == OrganisationTypeEnum.Supplier">
                <div class="ui-grid-col-4"><label>Supplier App Access?</label></div>
                <div class="ui-grid-col-8">
                  <p-checkbox
                    binary="true"
                    name="supplierAppAccess"
                    formControlName="supplierAppAccess"
                  ></p-checkbox>
                </div>
              </div>
            </div>
            <div
              *ngIf="selectOrganisationType == OrganisationTypeEnum.Supplier && junoEnabled"
              class="ui-g-12"
            >
              <div>
                <div class="ui-grid-col-4"><label>Default Search Type</label></div>
                <div class="ui-grid-col-8">
                  <p-dropdown
                    [options]="defaultSearchTypeOptions"
                    [(ngModel)]="defaultSearchType"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="onDefaultSearchTypeChange($event.value)"
                    styleClass="form-component"
                  ></p-dropdown>
                </div>
              </div>
            </div>
            <div *ngIf="selectOrganisationType == OrganisationTypeEnum.Supplier" class="ui-g-12">
              <mobile-informations [mobileInformations]="mobileInformations"></mobile-informations>
            </div>
            <div class="ui-g-12">
              <div
                class="ui-g-12"
                *ngIf="selectOrganisationType == 2 || selectOrganisationType == 5"
              >
                <div class="ui-grid-col-4"><label>Bypass Order Limitations?</label></div>
                <div class="ui-grid-col-8">
                  <p-checkbox
                    binary="true"
                    name="bypassOrderLimitations"
                    formControlName="bypassOrderLimitations"
                  ></p-checkbox>
                </div>
              </div>
            </div>
            <div class="ui-g-12">
              <div
                class="ui-g-12"
                *ngIf="
                  selectOrganisationType == 2 ||
                  selectOrganisationType == 4 ||
                  selectOrganisationType == 5
                "
              >
                <div class="ui-grid-col-4">
                  <label>Vehicle LifeCycle Enabled?</label>
                </div>
                <div class="ui-grid-col-8">
                  <p-checkbox
                    binary="true"
                    name="vehicleLifeCycleEnabled"
                    formControlName="vehicleLifeCycleEnabled"
                    [disabled]="currentUserOrgTypeId != 1"
                  ></p-checkbox>
                  <input
                    type="button"
                    pButton
                    value="Configure Providers"
                    (click)="configureLifeCycleProviders()"
                    [disabled]="
                      newCustomerForm.get('vehicleLifeCycleEnabled').value == false ||
                      currentUserOrgTypeId != 1
                    "
                    class="vlc-provider-config-btn"
                  />
                </div>
              </div>
            </div>

            <div class="ui-g-12">&nbsp;</div>

            <app-organisation-activation-control
              [organisationId]="id"
              [customerData]="customerdata"
            ></app-organisation-activation-control>

            <div
              class="ui-g-12 mb-20"
              *ngIf="
                customerdata &&
                (customerdata?.organisationTypeId == 2 || customerdata?.organisationTypeId == 5)
              "
            >
              <div class="ui-grid-col-8">
                <p-checkbox
                  binary="true"
                  name="enableCustomInvoiceReport"
                  formControlName="enableCustomInvoiceReport"
                  pTooltip="Enable Custom Invoice Report"
                  label="Enable Custom Invoice Report"
                ></p-checkbox>
              </div>
            </div>
          </div>

          <div class="ui-g-6 ui-sm-12 ui-g-nopad">
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Email</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="emailAddress"
                  formControlName="emailAddress"
                  tabindex="7"
                  maxlength="254"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Phone Number</label></div>
              <div class="ui-grid-col-8">
                <label>
                  +44
                  <input
                    pInputText
                    id="phoneNumber"
                    type="tel"
                    formControlName="phoneNumber"
                    tabindex="8"
                    maxlength="20"
                    class="form-component"
                  />
                </label>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4">
                <label>Company Registration No</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="companyRegistrationNumber"
                  formControlName="companyRegistrationNumber"
                  tabindex="9"
                  maxlength="8"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4">
                <label>Organisation Type</label>
              </div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  [options]="organisationtypes"
                  [disabled]="currentUserOrgTypeId != 1"
                  formControlName="OrganisationTypeId"
                  [(ngModel)]="selectOrganisationType"
                  autoWidth="false"
                  styleClass="form-component"
                  tabindex="10"
                >
                </p-dropdown>
              </div>
            </div>
            <div
              class="ui-g-12"
              *ngIf="selectOrganisationType != OrganisationTypeEnum.SaaSCustomer"
            >
              <div class="ui-grid-col-4">
                <label>Organisation Sub Type</label>
              </div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  [options]="organisationsubtypes"
                  [(ngModel)]="selectOrganisationSubType"
                  [disabled]="currentUserOrgTypeId != 1"
                  formControlName="OrganisationSubTypeId"
                  autoWidth="false"
                  styleClass="form-component"
                  tabindex="11"
                >
                </p-dropdown>
              </div>
            </div>
            <div
              class="ui-g-12"
              *ngIf="customerdata?.organisationTypeId == 3 || customerdata?.organisationTypeId == 4"
            >
              <div class="ui-grid-col-4">
                <label>Organisation Contract Type</label>
              </div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  id="organisationContractType"
                  [options]="organisationContractTypes"
                  [(ngModel)]="selectedOrganisationContractType"
                  [disabled]="currentUserOrgTypeId != 1"
                  formControlName="organisationContractTypeId"
                  autoWidth="false"
                  styleClass="form-component"
                  tabindex="12"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4">&nbsp;</div>
              <div class="ui-grid-col-8">
                <button
                  type="button"
                  pButton
                  label="Manage Contract Type History"
                  style="width: auto"
                  (click)="manageContractTypeHistory()"
                ></button>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>VAT number</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="vatNumber"
                  formControlName="vatNumber"
                  tabindex="13"
                  maxlength="12"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Website</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="website"
                  formControlName="website"
                  tabindex="14"
                  maxlength="254"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4">
                <label>Company Information URL</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="infoURL"
                  formControlName="companyInfoURL"
                  tabindex="15"
                  maxlength="1024"
                  class="form-component"
                />
              </div>
            </div>

            <!-- service delivery group contact details -->
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Engineius Contact Number</label></div>
              <div class="ui-grid-col-8">
                {{
                  customerdata?.serviceDeliveryGroup?.telephone ||
                    selectedServiceDeliveryGroup?.telephone ||
                    systemSettings?.engineiusPhone + ' (default)'
                }}
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4"><label>Engineius Email</label></div>
              <div class="ui-grid-col-8">
                {{
                  customerdata?.serviceDeliveryGroup?.email ||
                    selectedServiceDeliveryGroup?.email ||
                    defaultSupportEmail + ' (default)'
                }}
              </div>
            </div>

            <div
              class="ui-g-12"
              *ngIf="
                selectOrganisationSubType == 4 ||
                selectOrganisationSubType == 5 ||
                selectOrganisationSubType == 6
              "
            >
              <div class="ui-grid-col-4">
                <label>Engineius Customer Email</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="engineiusCustomerEmail"
                  formControlName="engineiusCustomerEmail"
                  tabindex="16"
                  maxlength="254"
                  class="form-component"
                />
              </div>
            </div>

            <div
              class="ui-g-12"
              *ngIf="
                selectOrganisationType == 2 ||
                selectOrganisationType == 3 ||
                selectOrganisationType == 5
              "
            >
              <div class="ui-grid-col-4"><label>Service Delivery Group</label></div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  id="sdg"
                  [options]="serviceDeliveryGroupOptions"
                  [(ngModel)]="selectedServiceDeliveryGroupId"
                  [disabled]="currentUserOrgTypeId != 1"
                  formControlName="serviceDeliveryGroupId"
                  (ngModelChange)="serviceDeliveryGroupChanged($event)"
                  autoWidth="false"
                  styleClass="form-component"
                  tabindex="17"
                >
                </p-dropdown>
              </div>
            </div>
            <!-- End of service delivery group contact details -->

            <div class="ui-g-12">
              <div class="ui-grid-col-4">
                <label>EC Flex Time in Minutes</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="maxFlexTime"
                  formControlName="ecMaxFlexTimeInMinutes"
                  tabindex="18"
                  maxlength="5"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4">
                <label>Agreed Terms & Conditions</label>
              </div>
              <div class="ui-grid-col-8">
                {{
                  termsConditions && termsConditions.isAgreed
                    ? 'ver. ' + termsConditions.version.version
                    : ''
                }}
              </div>
            </div>
            <div
              *ngIf="
                selectOrganisationSubType == 4 ||
                selectOrganisationSubType == 5 ||
                selectOrganisationSubType == 6
              "
              class="ui-g-12"
            >
              <div class="ui-grid-col-4"><label>GDPR Job Expiry Days</label></div>
              <div class="ui-grid-col-8">
                <input
                  type="number"
                  pInputText
                  id="gdprDays"
                  formControlName="gdprDays"
                  tabindex="19"
                  (keydown)="inputHelper.allowNumberInputKey($event, false)"
                  maxlength="4"
                  class="form-component"
                />
              </div>
            </div>

            <div
              *ngIf="customerdata && (selectOrganisationType == 3 || selectOrganisationType == 4)"
              class="ui-g-12"
            >
              <div class="ui-grid-col-12">
                <p-table
                  #dt
                  [value]="customerdata.tradePlates"
                  [(selection)]="selectedTradePlate"
                  selectionMode="single"
                  rowHover="true"
                  [style]="{ 'margin-bottom': '10px' }"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Trade Plate Number</th>
                      <th>Issue Date</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-item>
                    <tr>
                      <th>{{ item.number }}</th>
                      <th>
                        <div>
                          {{ item.dateIssued | datex : "ddd DD MMM 'YY HH:mm" }}
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                </p-table>

                <!-- DEPRECATED --
                  <p-dataTabl #dt [value]="customerdata.tradePlates" [(selection)]="selectedTradePlate"
                               selectionMode="single" rowHover="true" [style]="{'margin-bottom':'10px'}">
                    <p-column field="number" header="Trade Plate Number" [sortable]="false" [editable]="false"></p-column>
                    <p-column field="dateIssued" header="Issued Date" [sortable]="false" [editable]="false">
                      <ng-template let-item="rowData" pTemplate="body">
                        <div>
                          {{item.dateIssued | datex:'ddd DD MMM \'YY HH:mm'}}
                        </div>
                      </ng-template>
                    </p-column>
                  </p-dataTable>
                  -->

                <button
                  type="button"
                  pButton
                  (click)="unallocateTradePlate(selectedTradePlate)"
                  label="Unallocate"
                  class="btn-to-right ui-button-danger"
                  [disabled]="!selectedTradePlate"
                ></button>
              </div>
            </div>
            <div
              formArrayName="organisationDetails"
              *ngIf="selectOrganisationType == 3 || selectOrganisationType == 4"
              class="ui-g-12"
            >
              <div class="ui-grid-col-4"><label>Self-Insured</label></div>
              <div class="ui-grid-col-8">
                <p-checkbox
                  binary="true"
                  name="isSelfInsured"
                  formControlName="isSelfInsured"
                ></p-checkbox>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-col-4 ui-sm-12"><label>Logo</label></div>
              <div class="ui-grid-col-8 ui-sm-12">
                <div class="ui-g-12">
                  <div class="file-uploader-holder ui-sm-8 ui-md-8 ui-g-nopad">
                    <p-fileUpload
                      name="files"
                      url="/api/filestorage/uploadOrgLogo"
                      (onProgress)="progressUploading($event)"
                      (onBeforeUpload)="onBeforeUpload($event)"
                      (onSelect)="onSelect($event)"
                      (onError)="onError($event)"
                      (onUpload)="onFileUpload($event)"
                      withCredentials="true"
                      [maxFileSize]="83886080"
                      [accept]="'image/*'"
                      auto="true"
                      chooseLabel="Upload Logo"
                      mode="basic"
                    >
                    </p-fileUpload>
                  </div>
                  <button
                    [hidden]="!customer || !customer.logo.value"
                    pButton
                    type="button"
                    class="ui-button-danger delete-logo-btn ui-sm-4 ui-md-4"
                    style="margin-left: 10px"
                    icon="fa ui-icon-trash"
                    (click)="deleteLogo()"
                  ></button>
                </div>
                <div class="ui-g-12">
                  <a
                    *ngIf="customer && customer.logo.value"
                    href="#"
                    (click)="openLogo(customer.logo.value); $event.preventDefault()"
                  >
                    <img class="logo" src="{{ logoUrl }}" />
                  </a>
                </div>
              </div>
            </div>
            <div class="mt-4" *ngIf="selectOrganisationType == 2">
              <h2 class="bold-text">Carryover Config</h2>

              <div class="ui-g-12">
                <div>
                  <div class="ui-grid-col-4"><label>Restrict Carryover?</label></div>
                  <div class="ui-grid-col-8">
                    <p-checkbox
                      binary="true"
                      name="restrictCarryover"
                      formControlName="restrictCarryover"
                    ></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div>
                  <div class="ui-grid-col-4"><label>Restrict Weekend Carryover?</label></div>
                  <div class="ui-grid-col-8">
                    <p-checkbox
                      binary="true"
                      name="restrictWeekendCarryover"
                      formControlName="restrictWeekendCarryover"
                    ></p-checkbox>
                  </div>
                </div>
              </div>

              <div class="ui-g-12">
                <div>
                  <div class="ui-grid-col-4">
                    <label>Carryover Additional Mileage Threshold</label>
                  </div>
                  <div class="ui-grid-col-8">
                    <input
                      type="number"
                      pInputText
                      id="carryoverAdditionalMileageThreshold"
                      formControlName="carryoverAdditionalMileageThreshold"
                      tabindex="20"
                      (keydown)="inputHelper.allowNumberInputKey($event, false)"
                      maxlength="4"
                      class="form-component"
                    />
                    <span class="suffix">%</span>
                    <div
                      *ngIf="
                        newCustomerForm.get('carryoverAdditionalMileageThreshold').invalid &&
                        (newCustomerForm.get('carryoverAdditionalMileageThreshold').dirty ||
                          newCustomerForm.get('carryoverAdditionalMileageThreshold').touched)
                      "
                    >
                      <span
                        *ngIf="
                          newCustomerForm.get('carryoverAdditionalMileageThreshold').errors.required
                        "
                        class="text-red-500"
                        >Carryover Additional Mileage Threshold is required. Default value is
                        15%.</span
                      >
                      <span
                        *ngIf="
                          newCustomerForm.get('carryoverAdditionalMileageThreshold').errors.min
                        "
                        class="text-red-500"
                        >Value must be greater than or equal to 0.</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- INVOICE ADDRESS -->
        <div formArrayName="invoiceAddress" *ngIf="isVmeMode">
          <div class="ui-grid-row">
            <div class="ui-g-12">
              <h2 style="display: inline-block" (click)="showErrors()">Invoice Address</h2>
              <input
                tabindex="13"
                type="button"
                pButton
                value="Copy Address"
                (click)="InvoiceAddressSameAsAbove()"
                style="
                  width: 85px;
                  padding: 0;
                  height: 25px;
                  font-size: 0.8em;
                  border-radius: 3px;
                  margin-top: 10px;
                  margin-left: 10px;
                  margin-bottom: 15px;
                "
              />
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Address Line 1</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoice_addressLine1"
                  formControlName="addressLine1"
                  tabindex="14"
                  maxlength="60"
                  class="form-component"
                />
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Address Line 2</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoice_addressLine2"
                  formControlName="addressLine2"
                  tabindex="15"
                  maxlength="60"
                  class="form-component"
                />
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Address Line 3</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoice_addressLine3"
                  formControlName="addressLine3"
                  tabindex="16"
                  maxlength="60"
                  class="form-component"
                />
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4"><label>Town</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoice_town"
                  formControlName="town"
                  tabindex="17"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4"><label>Post Code</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoice_postcode"
                  formControlName="postCode"
                  tabindex="18"
                  maxlength="8"
                  class="form-component"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- BILLING -->
        <div formArrayName="invoiceAddress" *ngIf="isVmeMode">
          <div class="ui-grid-row">
            <div class="ui-g-12">
              <h2 style="display: inline-block">Billing</h2>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Company Name</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceCompanyName"
                  formControlName="invoiceCompanyName"
                  tabindex="19"
                  maxlength="100"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Period (days, or 0 for monthly)</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoicePeriod"
                  formControlName="invoicePeriod"
                  tabindex="30"
                  (keydown)="inputHelper.allowNumberInputKey($event, false)"
                  maxlength="2"
                  class="form-component"
                />
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact First Name</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContactFirstName"
                  formControlName="invoiceContactFirstName"
                  tabindex="20"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Purchase Order Number</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="purchaseOrderNumber"
                  formControlName="purchaseOrderNumber"
                  tabindex="31"
                  maxlength="100"
                  class="form-component"
                />
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact Last Name</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContactLastName"
                  formControlName="invoiceContactLastName"
                  tabindex="21"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Xero Payment Terms Type</label>
              </div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  [options]="paymentTermsTypes"
                  formControlName="paymentTermsType"
                  autoWidth="false"
                  styleClass="form-component"
                  tabindex="32"
                >
                </p-dropdown>
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact Email</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContactEmail"
                  formControlName="invoiceContactEmail"
                  tabindex="22"
                  maxlength="254"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Xero Payment Terms Days</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="paymentTermsDays"
                  (keydown)="inputHelper.allowNumberInputKey($event, false)"
                  formControlName="paymentTermsDays"
                  tabindex="33"
                  maxlength="3"
                  class="form-component"
                />
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact Phone</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContactPhone"
                  formControlName="invoiceContactPhone"
                  tabindex="23"
                  maxlength="20"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4"><label>Xero Contact ID</label></div>
              <div class="ui-grid-col-8">
                {{
                  customerdata && customerdata.invoiceAddress
                    ? customerdata.invoiceAddress.xeroContactId
                    : ''
                }}
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact 2 First Name</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContact2FirstName"
                  formControlName="invoiceContact2FirstName"
                  tabindex="24"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4"><label>Xero Contact Updated On</label></div>
              <div class="ui-grid-col-8">
                {{
                  customerdata && customerdata.invoiceAddress
                    ? (customerdata.invoiceAddress.xeroContactUpdatedOn
                      | datex : 'DD MMM YYYY HH:mm')
                    : ''
                }}
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact 2 Last Name</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContact2LastName"
                  formControlName="invoiceContact2LastName"
                  tabindex="25"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4"><label>Revolut Counterparty ID</label></div>
              <div class="ui-grid-col-8">
                {{
                  customerdata && customerdata.invoiceAddress
                    ? customerdata.invoiceAddress.revolutCounterpartyId
                    : ''
                }}
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact 2 Email</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContact2Email"
                  formControlName="invoiceContact2Email"
                  tabindex="26"
                  maxlength="254"
                  class="form-component"
                />
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4"><label>Revolut Counterparty Updated On</label></div>
              <div class="ui-grid-col-8">
                {{
                  customerdata && customerdata.invoiceAddress
                    ? (customerdata.invoiceAddress.revolutLastUpdated | datex : 'DD MMM YYYY HH:mm')
                    : ''
                }}
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact 3 First Name</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContact3FirstName"
                  formControlName="invoiceContact3FirstName"
                  tabindex="27"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>

            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Billing Wait Days</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="billingWaitDays"
                  formControlName="billingWaitDays"
                  tabindex="35"
                  (keydown)="inputHelper.allowNumberInputKey($event, false)"
                  maxlength="2"
                  class="form-component"
                />
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact 3 Last Name</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContact3LastName"
                  formControlName="invoiceContact3LastName"
                  tabindex="28"
                  maxlength="35"
                  class="form-component"
                />
              </div>
            </div>

            <div
              class="ui-g-6 ui-sm-12"
              *ngIf="
                selectOrganisationType == 2 ||
                selectOrganisationType == 4 ||
                selectOrganisationType == 5
              "
            >
              <div class="ui-grid-col-4">
                <label>Add Transaction Fee to Transaction Line</label>
              </div>
              <div class="ui-grid-col-8">
                <p-checkbox
                  binary="true"
                  name="isAddTransactionFee"
                  [formControl]="newCustomerForm.controls['isAddTransactionFee']"
                ></p-checkbox>
              </div>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Invoice Contact 3 Email</label>
              </div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  id="invoiceContact3Email"
                  formControlName="invoiceContact3Email"
                  tabindex="29"
                  maxlength="254"
                  class="form-component"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- DEFAULT OFFICE HOURS -->
        <div formArrayName="defaultOfficeHours">
          <div class="ui-grid-row">
            <div class="ui-g-12">
              <h2 class="sub-header-bar">Office Hours</h2>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-md-3 ui-g-12">
              <p-checkbox
                name="openWeekdays"
                binary="true"
                formControlName="openWeekdays"
              ></p-checkbox>
              <label>Open Weekdays</label>
            </div>

            <div class="ui-md-3 ui-g-6"><label>Weekday Opening Time</label></div>
            <div class="ui-md-1 ui-g-6">
              <p-calendar
                [disabled]="!customer.defaultOfficeHours.openWeekdays.value"
                formControlName="weekOfficeOpeningTime"
                styleClass="form-component"
                [timeOnly]="true"
                tabindex="40"
              >
              </p-calendar>
            </div>

            <div class="ui-md-3 ui-g-6"><label>Weekday Closing Time</label></div>
            <div class="ui-md-1 ui-g-6">
              <p-calendar
                [disabled]="!customer.defaultOfficeHours.openWeekdays.value"
                formControlName="weekOfficeClosingTime"
                styleClass="form-component"
                [timeOnly]="true"
                tabindex="43"
              >
              </p-calendar>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-md-3 ui-g-12">
              <p-checkbox
                name="openOnSaturday"
                binary="true"
                formControlName="openOnSaturday"
              ></p-checkbox>
              <label>Open Saturday</label>
            </div>

            <div class="ui-md-3 ui-g-6"><label>Saturday Opening Time</label></div>
            <div class="ui-md-1 ui-g-6">
              <p-calendar
                [disabled]="!customer.defaultOfficeHours.openOnSaturday.value"
                formControlName="saturdayOpeningTime"
                styleClass="form-component"
                [timeOnly]="true"
                tabindex="41"
              >
              </p-calendar>
            </div>
            <div class="ui-md-3 ui-g-6"><label>Saturday Closing Time</label></div>
            <div class="ui-md-1 ui-g-6">
              <p-calendar
                [disabled]="!customer.defaultOfficeHours.openOnSaturday.value"
                formControlName="saturdayClosingTime"
                styleClass="form-component"
                [timeOnly]="true"
                tabindex="44"
              ></p-calendar>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-md-3 ui-g-12">
              <p-checkbox
                name="openOnSunday"
                binary="true"
                formControlName="openOnSunday"
              ></p-checkbox>
              <label>Open Sunday</label>
            </div>

            <div class="ui-md-3 ui-g-6"><label>Sunday Opening Time</label></div>
            <div class="ui-md-1 ui-g-6">
              <p-calendar
                [disabled]="!customer.defaultOfficeHours.openOnSunday.value"
                formControlName="sundayOpeningTime"
                styleClass="form-component"
                [timeOnly]="true"
                tabindex="42"
              >
              </p-calendar>
            </div>

            <div class="ui-md-3 ui-g-6"><label>Sunday Closing Time</label></div>
            <div class="ui-md-1 ui-g-6">
              <p-calendar
                [disabled]="!customer.defaultOfficeHours.openOnSunday.value"
                formControlName="sundayClosingTime"
                styleClass="form-component"
                [timeOnly]="true"
                tabindex="45"
              ></p-calendar>
            </div>
          </div>
        </div>

        <!-- Allowed step types -->
        <div
          *ngIf="
            currentUserOrgTypeId == 1 &&
            (selectOrganisationType == 2 || selectOrganisationType == 5)
          "
        >
          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <h2 style="display: inline-block">Task Step Types</h2>
              <p-listbox
                name="stepTypes"
                [options]="stepTypes"
                multiple="multiply"
                formControlName="stepTypes"
                checkbox="checkbox"
                [metaKeySelection]="false"
                styleClass="form-component"
              >
              </p-listbox>
              {{ selectedStepTypes }}
            </div>

            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-row">
                <div class="ui-g-8 ui-sm-12">Min. Collection Window</div>
                <div class="ui-g-4 ui-sm-12">
                  <input pInputText class="inline-input" formControlName="minCollectionWindow" />
                  hours
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-g-8 ui-sm-12">Min. Delivery Window</div>
                <div class="ui-g-4 ui-sm-12">
                  <input pInputText class="inline-input" formControlName="minDeliveryWindow" />
                  hours
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="api-management-section" *ngIf="customerdata">
          <hr />
          <!--API Key-->
          <div class="ui-grid-row">
            <div class="ui-g-12">
              <h2 class="sub-header-bar">API Management</h2>
            </div>
          </div>

          <div class="ui-grid-row">
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-4">
                <label>Default API User</label>
              </div>
              <div class="ui-grid-col-8">
                <p-dropdown
                  [options]="organisationUsers"
                  [(ngModel)]="selectedApiDefaultUserId"
                  placeholder="Select a User"
                  formControlName="defaultAPIUserId"
                  autoWidth="false"
                  styleClass="form-component"
                  tabindex="11"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="ui-g-6 ui-sm-12">
              <div class="ui-grid-col-2 ui-sm-5"><label>API Key</label></div>
              <div class="ui-grid-col-10 ui-sm-7">
                <input
                  pInputText
                  id="apiKey"
                  readonly
                  [value]="
                    apiKeyRevealed
                      ? apiKey
                      : customerdata.hasApiKey
                      ? '••••••••••••••••••••••••••••••••'
                      : ''
                  "
                  [title]="apiKeyRevealed ? apiKey : ''"
                  [disabled]="!apiKeyRevealed"
                  (click)="$event.target.select()"
                  tabindex="31"
                  maxlength="36"
                  class="form-component api-key-input"
                />
              </div>
              <div class="ui-grid-col-12 api-key-buttons">
                <button
                  type="button"
                  pButton
                  [icon]="apiKeyRevealed ? 'fa ui-icon-visibility-off' : 'fa ui-icon-visibility'"
                  [label]="apiKeyRevealed ? 'Hide Key' : 'Reveal Key'"
                  [disabled]="apiKeyLoading || !customerdata.hasApiKey"
                  class="ui-button"
                  (click)="apiKeyRevealed ? hideApiKey() : revealApiKey()"
                ></button>
                <button
                  type="button"
                  pButton
                  icon="fa ui-icon-content-copy"
                  label="Copy Key"
                  [disabled]="!apiKeyRevealed || !apiKey"
                  class="ui-button"
                  (click)="copyApiKey()"
                ></button>
                <button
                  type="button"
                  pButton
                  icon="fa ui-icon-lock"
                  [label]="customerdata.hasApiKey ? 'Reset Key' : 'Create Key'"
                  class="ui-button amber-btn"
                  (click)="confirmApiKeyGeneration()"
                ></button>
              </div>
            </div>
          </div>
          <hr />
        </div>

        <!--EOF API Key-->

        <div class="ui-grid-row org-btn">
          <button
            type="button"
            (click)="cancel()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
            *ngIf="user === 'vme'"
          ></button>
          <button
            type="submit"
            icon="fa ui-icon-check"
            class="ui-button green-btn btn-to-right"
            pButton
            label="Save"
            [disabled]="newCustomerForm.invalid"
            tabindex="46"
            style="width: auto; float: right"
          ></button>
        </div>

        <ng-template #loading>Loading...</ng-template>
      </form>
      <!-- Booking summary settings -->
      <div
        *ngIf="
          customerdata &&
          (customerdata.organisationTypeId == 2 || customerdata.organisationTypeId == 5)
        "
      >
        <app-booking-summary-settings [organisationId]="id"></app-booking-summary-settings>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  key="api-key-generation-dialog"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>

<p-dialog
  *ngIf="isVmeMode"
  header="Manage Vehicle LifeCycle Provider Configuration"
  [(visible)]="vehicleLifeCycleManageProvidersVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px', height: '400px' }"
>
  <div>
    <div class="col-12 mb-4">
      <strong
        >Please select a provider from the list below to configure the required API
        credentials</strong
      >
    </div>
    <div class="col-12 mb-4">
      <div class="ui-grid-col-4">
        <label><strong>Provider</strong></label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="vehicleLifeCycleProviders"
          [optionLabel]="'name'"
          [dataKey]="'id'"
          [autoDisplayFirst]="false"
          styleClass="form-component"
          (onChange)="selectLifeCycleProvider($event.value)"
          placeholder="Select Provider"
          [(ngModel)]="vehicleLifeCycleSelectedProvider"
        >
        </p-dropdown>
      </div>
    </div>
    <form [formGroup]="vehicleLifeCycleProviderConnectionFormGroup">
      <div class="ui-g-12 mb-2">
        <div class="ui-grid-col-4">
          <label for="apiUrl"><strong>API URL</strong></label>
        </div>
        <div class="ui-grid-col-8">
          <input pInputText class="form-component" formControlName="apiUrl" id="apiUrl" />
        </div>
      </div>
      <div class="ui-g-12 mb-2">
        <div class="ui-grid-col-4">
          <label for="usernameKey"><strong>Username Key</strong></label>
        </div>
        <div class="ui-grid-col-8">
          <input pInputText class="form-component" formControlName="usernameKey" id="usernameKey" />
        </div>
      </div>
      <div class="ui-g-12 mb-4">
        <div class="ui-grid-col-4">
          <label for="passwordKey"><strong>Password Key</strong></label>
        </div>
        <div class="ui-grid-col-8">
          <input pInputText class="form-component" formControlName="passwordKey" id="passwordKey" />
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="button-box">
      <button
        class="btn-to-right"
        label="Save Changes"
        pButton
        type="button"
        [disabled]="
          !vehicleLifeCycleProviderConnectionFormGroup.valid || vehicleLifeCycleProviderUpdateSaving
        "
        (click)="saveLifeCycleProviderConnection()"
      ></button>
      <button
        class="btn-to-right"
        label="Close"
        pButton
        type="button"
        (click)="vehicleLifeCycleManageProvidersVisible = false"
      ></button></div
  ></p-footer>
</p-dialog>
